import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

import type SessionContextService from 'tio-employee/services/session-context';
import type { AuthenticatedSyfRouteModel } from '../../syf';
import type PersonModel from 'tio-common/models/person';

export default class AuthenticatedSyfPaymentsNewRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const person = await this.store.findRecord<PersonModel>(
      'person',
      // @ts-expect-error type models
      this.sessionContext.user.person.id,
      {
        include: 'accounts',
        reload: true,
      }
    );

    const parentModel = this.modelFor('authenticated.syf') as AuthenticatedSyfRouteModel;
    const matchParticipant = parentModel.matchParticipant;

    return {
      matchParticipant,
      accounts: person.activeAccounts,
    };
  }
}
